import { render } from "./DataInventoryAnalysisPvt.vue?vue&type=template&id=f1e1310e"
import script from "./DataInventoryAnalysisPvt.vue?vue&type=script&lang=js"
export * from "./DataInventoryAnalysisPvt.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__